import Vue from 'vue'

export default {  
  getLookups ({ commit }, type) {    
    return new Promise((resolve, reject) => {
      Vue.prototype.$api.lookups().list(type)
        .then(response => {    
          localStorage.setItem(type, JSON.stringify(response.data))

          commit('lookups_request', { type: type, data: response.data })        
        
          resolve(response)
        }).catch(err => {        
          reject(err)
        })  
    })
  },
  getStates ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$api.states().list()
        .then(response => {    
          localStorage.setItem('states', JSON.stringify(response.data))

          commit('states_request', { data: response.data })        
        
          resolve(response)
        }).catch(err => {        
          reject(err)
        })  
    })
  },
  getCities ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$api.cities().list()
        .then(response => {    
          localStorage.setItem('cities', JSON.stringify(response.data))

          commit('cities_request', { data: response.data })        
        
          resolve(response)
        }).catch(err => {        
          reject(err)
        })  
    })
  },
  getPostcodes ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$api.postcodes().list()
        .then(response => {    
          localStorage.setItem('postcodes', JSON.stringify(response.data))

          commit('postcodes_request', { data: response.data })        
        
          resolve(response)
        }).catch(err => {        
          reject(err)
        })  
    })
  },
}
